import BSOatsOatmealProduct from 'models/BSOatsOatmealProduct'

export const packagingInitialState = {
  category: BSOatsOatmealProduct.category,
  subCategory: BSOatsOatmealProduct.subCategory,
  OatType: BSOatsOatmealProduct.OatType,
  OtherType: BSOatsOatmealProduct.OtherType,
  Size: BSOatsOatmealProduct.Size,
  Variety: BSOatsOatmealProduct.Variety,
  OtherVariety: BSOatsOatmealProduct.OtherVariety,
  CookingType: BSOatsOatmealProduct.CookingType,
}

export const oatTypeOptions = [
  {
    value: '',
    label: 'Oat Type',
    isDisabled: true,
  },
  {
    value: 'Rolled',
    label: 'Rolled',
  },
  { value: 'Cut', label: 'Cut' },
  { value: 'Steel Cut', label: 'Steel Cut' },
  { value: 'Other', label: 'Other' },
]

export const cookingTypeOptions = [
  {
    value: '',
    label: 'Oat Cooking Type',
    isDisabled: true,
  },
  {
    value: 'Regular',
    label: 'Regular',
  },
  { value: 'Quick', label: 'Quick' },
  { value: 'Instant', label: 'Instant' },
]

export const varietyOptions = [
  {
    value: '',
    label: 'Oat Variety',
    isDisabled: true,
  },
  {
    value: 'Regular',
    label: 'Regular',
  },
  { value: 'Old Fashioned', label: 'Old Fashioned' },
  { value: 'Other', label: 'Other' },
]
